import React from 'react'
import { useAuth } from '../../hooks/useAuth'
import AmbulanceAssetManagementPage from './AmbulanceAssetManagementPage'
import CemeteryAssetManagementPage from './CemeteryAssetManagementPage'
import ProviderAssetsPage from './ProviderAssetsPage'

const AssetsRouter: React.FC = () => {
  const { user } = useAuth()

  // Route to appropriate asset management page based on user role
  switch (user?.role) {
    case 'AMBULANCE_PROVIDER':
      return <AmbulanceAssetManagementPage />
    case 'CEMETERY_PROVIDER':
      return <CemeteryAssetManagementPage />
    case 'PROVIDER':
    case 'USTADZ':
    case 'VENDOR':
    default:
      // For other provider types, use the generic page
      return <ProviderAssetsPage />
  }
}

export default AssetsRouter